import request from './request'
// 获取我的商品库
export function getMygoodsList(data) {
  return request({
    url: '/dy/business/myitemslist',
    method: 'post',
    data
  })
}
// 商品上下架
export function goodsShelve(data) {
  return request({
    url: '/dy/business/shelve',
    method: 'post',
    data
  })
}
// 编辑商品
export function editGoods(data) {
  return request({
    url: '/dy/business/editinfo',
    method: 'post',
    data
  })
}
// 获取服务费率
export function getServePercent(data) {
  return request({
    url: '/dy/business/getpayrate',
    method: 'post',
    data
  })
}
// 设置服务费率
export function setServePercent(data) {
  return request({
    url: '/dy/business/setpayrate',
    method: 'post',
    data
  })
}
// 招商活动列表
export function applyForList(data) {
  return request({
    url: '/dy/business/secondact',
    method: 'post',
    data
  })
}
// 报名招商活动
export function applyActive(data) {
  return request({
    url: '/dy/business/applyActive',
    method: 'post',
    data
  })
}